import { Transform, Type } from 'class-transformer';

import {
  ArrayNotEmpty,
  IsArray,
  IsBoolean,
  IsDateString,
  IsEnum,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsPositive,
  IsString,
  IsUUID,
  ValidateIf,
  ValidateNested,
} from 'class-validator';
import { ProductUnit } from '@coworkrz/products/types';
import { CastHelper } from './cast.helper';
import { BaseFiltersDto } from './base.dto';

export class SubscriptionDto {
  @IsNotEmpty()
  @IsUUID()
  product!: string;

  @IsNotEmpty()
  @IsPositive()
  @Transform(({ value }) =>
    CastHelper.toNumber(value, { default: 1, min: 1, max: 1 })
  )
  quantity!: number;

  @IsOptional()
  @IsDateString()
  startDate!: Date;

  @IsEnum(ProductUnit)
  priceUnit!: ProductUnit;

  @IsOptional()
  @IsArray()
  memberIds?: string[];

  @IsOptional()
  @IsArray()
  fromSubscriptionIds?: string[];
}

export class AddSubscriptionDto {
  @IsNotEmpty()
  @ValidateIf((o) => !o.teamId)
  cardNumber!: string;

  @IsArray()
  @ArrayNotEmpty()
  @ValidateNested({ each: true })
  @Type(() => SubscriptionDto)
  cartItems!: SubscriptionDto[];

  @IsOptional()
  @IsUUID()
  teamId?: string;
}

export class UpdateSubscriptionDto {
  @IsOptional()
  @IsBoolean()
  autoRenew?: boolean;
}

export class SubscriptionsFiltersDto extends BaseFiltersDto {
  @IsOptional()
  @Transform(({ value }) => CastHelper.toBoolean(value))
  active?: boolean;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  productName?: string;

  @IsOptional()
  @Transform(({ value }) => CastHelper.toNumber(value))
  @IsNumber()
  remainingDays?: number;

  @IsOptional()
  @Transform(({ value }) =>
    CastHelper.toNumber(value, { default: 1, min: 1, max: 2 })
  )
  @IsNumber()
  expiredDuration?: number;

  @IsOptional()
  @Transform(({ value }) => CastHelper.toBoolean(value))
  @IsBoolean()
  autoRenew?: boolean;

  @IsOptional()
  @Transform(({ value }) => CastHelper.toBoolean(value))
  withCard?: boolean;
}
